export default __webpack_public_path__ + "static/media/linkedin.d4045664.svg";